/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetProcessTypeDependencyGraphQueryResponse } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetProcessTypeDependencyGraph";

function getDocumentUseCasesControllerGetProcessTypeDependencyGraphUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/processings/process-type-graph` as const }  
  return res
}

/**
 * @description Returns the dependency graph of all document process types, showing which types depend on others. Use this to understand execution order and validate reprocessing requests.
 * @summary Get the process type dependency graph
 * {@link /api/v1/documents/processings/process-type-graph}
 */
export async function documentUseCasesControllerGetProcessTypeDependencyGraph(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerGetProcessTypeDependencyGraphQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDocumentUseCasesControllerGetProcessTypeDependencyGraphUrl().url.toString(), ... requestConfig })  
  return res.data
}